var $9efb74877777657a$exports = {};
$9efb74877777657a$exports = {
    "loading": `Laster inn ...`,
    "loadingMore": `Laster inn flere ...`
};


export {$9efb74877777657a$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
